import React, { useState } from 'react';
import { Box, Grid } from '@material-ui/core';
import { sizes } from 'src/styles/Media.styled';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import edit from 'src/assets/images/Edit.svg';
import CustomLabel from 'src/pages/reportUsage/common/customLabel/CustomLabel';
import TextWithClicks from 'src/pages/reportUsage/common/textWithClicks/TextWithClicks';
import { useStyles } from '../itemsToBeBilled/ItemsToBeBilled';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const AccountOwnedItems = ({
    accountOwnedItems,
    navigateToSpecifiedScreen,
}) => {
    const { t } = useTranslation();
    const [accOwnedCard, toggleAccOwnedCard] = useState(false);
    const classes = useStyles();
    const mediaSizes = {
        titleArea: 6,
        buttonnsArea: 6,
        xs: 3,
        lg: 2,
    };
    const usageOrderSubmission = useSelector(
        (state) => state.reportUsageRootReducer.usageOrderSubmission
    );

    const isSubmitClicked = useSelector(
        (state) => state.reportUsageRootReducer.isSubmitClicked
    );

    const orderStatus = useSelector(
        (state) => state.reportUsageRootReducer.orderStatus
    );

    const restrictReviewScreen = useSelector(
        (state) => state.reportUsageRootReducer.restrictReviewScreen
    );

    const isUsagedSubmittedSuccessfully =
        (usageOrderSubmission && usageOrderSubmission.statusCode === '200') ||
        (Object.keys(orderStatus).length > 0 &&
            orderStatus.status &&
            orderStatus.status.includes('Usage Order Submitted Successfully'));

    return (
        <div style={{ marginBottom: '10px', marginTop: '10px' }}>
            <CollapsableCard id="reportUsage-accountOwnedItemsMobile-nonBilledItems-notBilledAccountOwned"
                title={t('reportUsage.summary.NotBilledAccountOwned')}
                onClick={() => toggleAccOwnedCard(!accOwnedCard)}
                isExpanded={accOwnedCard}
                editButton={
                    isUsagedSubmittedSuccessfully ||
                    isSubmitClicked ||
                    !restrictReviewScreen
                        ? null
                        : edit
                }
                editPage={() => navigateToSpecifiedScreen('Record')}
                noCardData={accountOwnedItems?.length === 0}
            >
                {accOwnedCard &&
                    accountOwnedItems &&
                    accountOwnedItems.map((item, index) => (
                        <Box
                            key={index}
                            className={classes.paper}
                            my={1}
                            bgcolor={'#ffffff'}
                            boxShadow={2}
                            borderRadius={6}
                        >
                            <div style={{ paddingBottom: '1rem' }}>
                                <Grid lg={12} md={6} sm={6} xs={12}>
                                    <TextWithClicks
                                        classes={classes}
                                        media={mediaSizes}
                                        leftTitle={item.productCFN}
                                        justifyContentVal={'flex-end'}
                                        typeNonTissue={
                                            item.salesOrg === 'S002'
                                                ? 'NT'
                                                : item.salesOrg === 'S030' &&
                                                  'T'
                                        }
                                        typeEA={item.uom}
                                    />
                                    <CustomLabel
                                        fSize={'12px !important'}
                                        paddingRight={'4rem!important'}
                                        color={'#140F4B'}
                                        label={item.description}
                                        opacity={0.7}
                                    />
                                    {item.lotSerialNumber && (
                                        <CustomLabel
                                            fSize={'12px !important'}
                                            paddingRight={'2rem!important'}
                                            color={'#140F4B'}
                                            label={`${t(
                                                'reportUsage.review.itemsToBeBilled.ItemsToBeBilled.lotSerial'
                                            )} ${item.lotSerialNumber}`}
                                        />
                                    )}
                                </Grid>
                            </div>
                            <Grid
                                item
                                xs={1}
                                lg={1}
                                md={1}
                                spacing={1}
                                alignItems={'flex-start'}
                                justifyContent={
                                    window.innerWidth >= sizes.mediumDevice
                                        ? 'space-between'
                                        : 'flex-end'
                                }
                            >
                                <CustomLabel
                                    fSize={'12px !important'}
                                    color={'#202124'}
                                    fWeight={'bold'}
                                    paddingRight={'2rem!important'}
                                    label={
                                        item.usedQuantity
                                            ? `${t(
                                                  'reportUsage.review.itemsToBeBilled.ItemsToBeBilled.used'
                                              )} ${item.usedQuantity}`
                                            : item.otherQuantity
                                            ? `${t(
                                                  'reportUsage.review.itemsToBeBilled.ItemsToBeBilled.other'
                                              )} ${item.otherQuantity}`
                                            : ''
                                    }
                                />
                            </Grid>
                        </Box>
                    ))}
            </CollapsableCard>
        </div>
    );
};

export default AccountOwnedItems;
